module.exports = __webpack_public_path__ + "static/img/266_TO8_2354_og.8fa3e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/266_TO8_2354_og.jpg
// module id = rqRl
// module chunks = 0